import React from 'react';
import { Box, Flex, Text, Grid } from '@chakra-ui/react';
import {
  CheckGreenIcon,
  GoogleCalendarIcon,
  GoogleCalendarIconSetting,
  ICloudIconList,
  OutLookIcon,
} from '@mybridge/icons';
import { ExchangeIcon } from '@mybridge/icons/ExchangeIcon';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

// Individual Calendar Card Component
const CalendarCard = ({
  icon,
  title,
  description,
  isConnected,
  setSelectedComponent,
  setIsopenDetailedView,
  isMobile,
  translationKey,
  descriptionKey,
  t
}) => (
  <Box
    borderWidth="1px"
   //borderRadius="md"
    borderRadius="20px"
    overflow="hidden"
    cursor="pointer"
    boxShadow="md"
    _hover={{
      boxShadow: '0px 0px 12px 0px #00000033',
    }}
    p={4}
    minW="50%"
    h="220px"
    onClick={() => {
      if (!isMobile) {
        setIsopenDetailedView(title);
      }else{
        setSelectedComponent()
      }
    }}
  >
    <Flex justifyContent="space-between" alignItems="center" my={4}>
      {/* Render the calendar icon */}
      {icon}
      {/* Show the 'Connected' badge if isConnected is true */}
      {isConnected && (
        <Flex alignItems="center" fill="#127731" h="42px">
          <CheckGreenIcon />
          <Text fontSize={16} color="#127731" ml={2}>
            {useTranslator().t('myCalendar.connected') || "Connected"}
          </Text>
        </Flex>
      )}
    </Flex>
    {/* Display the calendar title */}
    <Text w="full" fontWeight="medium" textTransform={'capitalize'} color="#5B5B5B" fontSize="18px">
      {t(translationKey) || title}
    </Text>
    {/* Display the calendar description */}
    <Text fontSize="18px" mt={4} color="#747474" title={description}>
      {description?.length>60?description.substring(0,60)+"...":description}
    </Text>
  </Box>
);

// Main Component for Video Conferencing Integration
const VideoConferencingIntegration = ({
  setIsopenDetailedView,
  setSelectedComponent,
  calendars,
  isMobile,
  t
}) => {
  // Check if calendars array is valid
  if (!calendars || !Array.isArray(calendars) || calendars.length === 0) {
    return (
      <Text fontSize="20px" color="red" textAlign="center" mt={8}>
        {useTranslator().t('settingsIntegration.noVideoIntegrations') || "No video conferencing integrations available."}
      </Text>
    );
  }
  // const { t } = useTranslator();

  return (
    <Grid
      pt={8}
      templateColumns={isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}
      gap={4}
    >
      {/* Render a CalendarCard for each calendar */}
      {calendars.map((calendar, index) => (
        <CalendarCard
        setSelectedComponent={()=> setSelectedComponent(t(calendar.translationKey) || calendar.title)}
          key={index} // Unique key for each CalendarCard
          {...calendar} // Spread the calendar properties
          setIsopenDetailedView={setIsopenDetailedView} // Pass the function to handle detailed view
          isMobile={isMobile}
          t={t}
        />
      ))}
    </Grid>
  );
};

export default VideoConferencingIntegration;
